import React, {useEffect, useRef} from 'react'
import Fade from 'react-reveal/Fade'

const LandingBanner = ({items}) => {
  const [active, setActive] = React.useState(null);
  const [scale, setScale] = React.useState(1);
  const [screen, setScreen] = React.useState(1);
  const [dim, setDim] = React.useState(1);
  const cont = useRef(null);

  useEffect(() => {
    const _a = Math.floor(items.length * Math.random())
    setActive(_a);

    const measureImage = (el) => {
      let img = new Image()
      img.onload = (event) => {
        setDim(event.target.width / event.target.height)
      }

      let src = window.innerWidth < 900 ? el.mobileImage : el.desktopImage
      img.src = src.localFile.childImageSharp.gatsbyImageData.images.fallback.src
    }

    const onScroll = () => {
      let box = cont?.current.getBoundingClientRect()
      if (!box) return;
      let screenY = window.innerHeight
      // More easing funcs found at: https://gist.github.com/gre/1650294
      let easeInOutQuad = t => t<.5 ? 2*t*t : -1+(4-2*t)*t
      let _scale = (Math.abs(1 - ((box.top + screenY) / screenY))).toFixed(3)
      const SIZE_SCALE = 5 // formula = 100 / desired_increase  (ie: 100 / 20 = 5)
      _scale = easeInOutQuad(_scale) / SIZE_SCALE + 1

      setScale(_scale)
      setScreen(window.innerWidth / screenY)
    }

    measureImage(items[_a])
    onScroll()

    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, []);

  let size = scale * 100 + '%'
  size = dim > screen ? `auto ${size}` : `${size} auto`

  let style = { 
    backgroundSize: size,
  }

  return (
    <section className="landing-banner" ref={cont}>
      {active !== null && (
        <div className="landing-banner__background">
          <div 
            className="landing-banner__background-desktop" 
            //image={getImage(items[active].desktopImage.localFile)} alt={items[active].desktopImage.altText}
            style={{
              backgroundColor: `url(${items[active].desktopImage.localFile.childImageSharp.gatsbyImageData.backgroundColor})`,
              backgroundImage: `url(${items[active].desktopImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src})`,
            }}
          />
          <div 
            className="landing-banner__background-mobile" 
            //image={getImage(items[active].mobileImage.localFile)} alt={items[active].mobileImage.altText}
            style={{
              backgroundColor: `url(${items[active].mobileImage.localFile.childImageSharp.gatsbyImageData.backgroundColor})`,
              backgroundImage: `url(${items[active].mobileImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src})`,
            }}
          />
        </div>
      )}
      <div className="landing-banner__inner">
        <div className="landing-banner__content" data-sal='fade' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
          <h1>{active !== null && items[active].title}</h1>
        </div>
      </div>
    </section>
  );
};

export default LandingBanner;